import {Namespace} from 'enums-lib';
import {FieldMetaDataUnion, IBullhornFieldMeta, ISalesforceFieldMeta} from './imetadata';

export class FieldMetaTypeGuards {
  static isBullhorn(field: FieldMetaDataUnion): field is IBullhornFieldMeta {
    return field.namespace === Namespace.bullhorn;
  }

  static isSalesforce(field: FieldMetaDataUnion): field is ISalesforceFieldMeta {
    return field.namespace === Namespace.salesforce;
  }

  static hasOptions(field: FieldMetaDataUnion): field is IBullhornFieldMeta {
    return FieldMetaTypeGuards.isBullhorn(field) && !!(field.options?.length);
  }
}
